import { useDataChange } from 'Simple/Data.js'

export function useOnClickReceivables(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.view_mode',
    viewPath: props.viewPath,
  })
  return function onClick() {
    change('receivables')
  }
}

export function useOnClickTransactions(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.view_mode',
    viewPath: props.viewPath,
  })
  return function onClick() {
    change('transactions')
  }
}

export function useOnClickNotes(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.view_mode',
    viewPath: props.viewPath,
  })
  return function onClick() {
    change('notes')
  }
}
